__turbopack_context__.v({
  "youtubeContainer": "YouTubeVideo-module-scss-module__h4ldBq__youtubeContainer",
  "youtubeFrame": "YouTubeVideo-module-scss-module__h4ldBq__youtubeFrame",
});
